import Modal from "react-bootstrap/Modal";
import { useRef, useState } from "react";
import axiApi from "ApiCaller";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import { SwalAlertClass } from "core/swalClass";

const ModalModMassive = ({ show, setShow, items, setItemsShow, firstFetchContainers }) => {
    const { t: _Tc } = useTranslation("choices");
    const { t: _Tt } = useTranslation("tags");
    const { t: _Tf } = useTranslation("forms");
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const formModalRef = useRef(null);
    const handleClose = () => {
        setShow(false);
    };

    const onSummit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(formModalRef.current);
        const uids = items.current.chosen;
        const DataSend = {
            status: formData.get("status"),
            active: formData.get("active") === "on" ? true : false,
            uids: uids,
        };
        try {
            const resp = await axiApi.post(`/api/assets/massive/`, DataSend);
            if (resp.data.status) {
                setShow(false);
                firstFetchContainers();
                Alert.success(_Tf("labels.success"), _Tf("success.title"));
            } else {
                Alert.error(_Tf("labels.error"));
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
            Alert.error(_Tf("labels.error"));
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="dumpster" />
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">Modificación Masiva</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p className="h5 text-center mb-4">Se han seleccionado {items.current.chosen.length} contenedores.</p>
                    <form className="ms-auto" ref={formModalRef}>
                        <div className="row d-flex justify-content-center">
                            <div className="col-3 text-end">
                                <label htmlFor="modMass-status" className="col-form-label">
                                    {_Tt("common.status")}
                                </label>
                            </div>
                            <div className="col-9">
                                <Form.Select className="mb-2" id="modMass-status" name="status" style={{ maxWidth: "130px" }}>
                                    <option value="ac">{_Tc("containerStatus.ac")}</option>
                                    <option value="rp">{_Tc("containerStatus.rp")}</option>
                                    <option value="rs">{_Tc("containerStatus.rs")}</option>
                                    <option value="ds">{_Tc("containerStatus.ds")}</option>
                                    <option value="cb">{_Tc("containerStatus.cb")}</option>
                                    <option value="ns">{_Tc("containerStatus.ns")}</option>
                                </Form.Select>
                            </div>
                        </div>
                        <div className="row d-flex w-100 justify-content-center">
                            <div className="col-3 text-end">
                                <label htmlFor="active" className="col-form-label">
                                    Modo
                                </label>
                            </div>
                            <div className="col-9 d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="active"
                                    name="active"
                                    defaultChecked={true}
                                />
                            </div>
                        </div>
                    </form>
                </Modal.Body>



                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onSummit}>
                        Aceptar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalModMassive;
